import { render, staticRenderFns } from "./Collections.vue?vue&type=template&id=2ac3fd4d"
import script from "./Collections.vue?vue&type=script&lang=js"
export * from "./Collections.vue?vue&type=script&lang=js"
import style0 from "./Collections.vue?vue&type=style&index=0&id=2ac3fd4d&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports